var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAudioPlay = function SvgAudioPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9v6H2V9h1zm13-7L7 7v2.288l7-3.889v13.202l-7-3.889V17l9 5V2zm6.416 2.768-4.332 2.5 1 1.732 4.332-2.5-1-1.732zM5 7H0v10h5V7zm19 4h-5v2h5v-2zm-4.916 4-1 1.732 4.332 2.5 1-1.732-4.332-2.5z"
  })));
};

export default SvgAudioPlay;